import React, { Component } from 'react';
import {BrowserRouter} from 'react-router-dom';
import {Route} from 'react-router-dom';
import './App.css';

import HomeNew from './Components/HomeNew';
import Portfolio from './Components/Portfolio';
import Contact from './Components/Contact';
import Header from './Components/Header';
import Footer from './Components/Footer';
import ProjectBajookieland from './Components/Project-Bajookieland.js';
import ProjectAdditiveDrinking from './Components/Project-Additive-Drinking.js';
import ProjectPortals from './Components/Project-Portals.js';
import ProjectRedesign from './Components/Project-Redesign.js';
import ProjectCooperheadArt from './Components/Project-Cooperhead-Art.js';
import ProjectPlazaDelBeero from './Components/Project-Plaza-Del-Beero.js';
import ProjectCommunitee from './Components/Project-Communitee.js';
import ProjectBizGainz from './Components/Project-BizGainz.js';

class App extends Component {

  render () {
    return (

      <div>
        <BrowserRouter>
          <div id="" className="App">
            <Header></Header>

            <Route path="/" exact component={HomeNew} /> 
            <Route path="/index.html" exact component={HomeNew} />
            <Route path="/portfolio" exact component={Portfolio} />
            <Route path="/about" exact component={HomeNew} />
            <Route path="/contact" exact component={Contact} />

            <Route path="/additive-drinking" exact component={ProjectAdditiveDrinking} />
            <Route path="/AdditiveDrinking" exact component={ProjectAdditiveDrinking} />
            <Route path="/bajookieland" exact component={ProjectBajookieland} />
            <Route path="/portals" exact component={ProjectPortals} />
            <Route path="/redesign" exact component={ProjectRedesign} />
            <Route path="/cooperhead-art" exact component={ProjectCooperheadArt} />
            <Route path="/plaza-del-beero" exact component={ProjectPlazaDelBeero} />
            <Route path="/communitee" exact component={ProjectCommunitee} />
            <Route path="/bizgainz" exact component={ProjectBizGainz} />

            <Footer></Footer>

          </div>
        </BrowserRouter>
      </div>

        

        
    );

  }
}

export default App;